export default __webpack_public_path__ + "static/media/trucksInaLineBW.cde5eb24.jpg";